import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, Smartphone } from 'lucide-react';
import { isMobile } from 'react-device-detect';

const NATIVE_APP_URL = 'https://expo.dev/accounts/hed/projects/projector-watch';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hed.projectorwatch';
const APP_STORE_URL = 'https://apps.apple.com/app/projector-watch/id123456789';

export function QRCodeDownload() {
  const handleDownload = () => {
    if (isMobile) {
      // Rediriger vers le store approprié
      const isAndroid = /android/i.test(navigator.userAgent);
      window.location.href = isAndroid ? PLAY_STORE_URL : APP_STORE_URL;
    } else {
      // Ouvrir l'URL Expo Go dans un nouvel onglet
      window.open(NATIVE_APP_URL, '_blank');
    }
  };

  return (
    <Card className="hover:shadow-lg transition-all">
      <CardHeader>
        <div className="flex items-center gap-2">
          <Smartphone className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold">Application mobile</h2>
        </div>
      </CardHeader>
      <CardContent className="flex flex-col items-center gap-6">
        <div className="bg-white p-4 rounded-lg shadow-inner">
          <QRCodeSVG
            value={NATIVE_APP_URL}
            size={200}
            level="H"
            includeMargin
            imageSettings={{
              src: "/icon-192x192.png",
              x: undefined,
              y: undefined,
              height: 40,
              width: 40,
              excavate: true,
            }}
          />
        </div>

        <div className="text-center">
          <p className="text-gray-600 mb-4">
            Scannez ce QR code pour télécharger l'application mobile Projector Watch
            {!isMobile && " ou utilisez Expo Go pour tester l'application"}
          </p>

          <Button onClick={handleDownload} className="gap-2">
            <Download className="w-4 h-4" />
            {isMobile ? "Télécharger l'application" : "Ouvrir dans Expo Go"}
          </Button>
        </div>

        {!isMobile && (
          <div className="text-sm text-gray-500 text-center">
            <p>Vous aurez besoin de l'application Expo Go pour tester Projector Watch</p>
            <div className="flex justify-center gap-4 mt-2">
              <a
                href="https://play.google.com/store/apps/details?id=host.exp.exponent"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Android
              </a>
              <a
                href="https://apps.apple.com/app/expo-go/id982107779"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                iOS
              </a>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}